import React from "react"
import Menu from '../../Components/Menu/Menu'
import styles from './Select-ItemContainer.module.css';
import {SelectedCYNYSymbol} from './child_Select-ItemContainer/selectedCYNYSymbol';
import {SelectCYNYConnection} from './child_Select-ItemContainer/selectedCYNYConnection';
import {message} from "antd";

const showMessage = (typeofMessage, content) => {
    message[typeofMessage]({content, style: {marginTop: '45px'}, duration: 2})
};
export default class SelectItemContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedObject: null,
            title: null,
        };
        this.container = React.createRef();
    }


    componentDidMount() {
        const {graph} = this.props;
        if (graph) {
            const selectedCell = graph.getSelectionCell();
            if (selectedCell) {
                this.setState({selectedObject: selectedCell})
            }
            this.addCellsSelectionListeners();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.graph !== this.props.graph) {
            this.addCellsSelectionListeners();
        }
    }

    componentWillUnmount() {
        this.removeCellsSelectionListeners();
    }

    onUpdateConnectionData = (oldName, newName) => {
        const {graph} = this.props;
        graph.setConnectionsGroupName(oldName, newName);
    };

    onUpdateSymbolData = (newName, oldName) => {
        const {graph} = this.props;
        const {selectedObject} = this.state;
        if (!selectedObject.hasManualPackageName()) {
            /**
             * In case we didn't have ManualPackageName set on the symbol, write oldName = null to the history
             */
            oldName = null;
        }
        selectedObject.changePackageProperty(newName);
        /**
         * Save event to history
         */
        graph.fireSetSymbolNameEvent(newName, oldName, selectedObject);

    };

    onCellSelectionAdd = (sender, me) => {
        const cell = me.getProperty('state').cell;
        this.setState({selectedObject: cell});
    };

    addCellsSelectionListeners = () => {
        const {graph} = this.props;
        graph.selectionCellsHandler.addListener(window.mxEvent.ADD, this.onCellSelectionAdd);
    };

    removeCellsSelectionListeners = () => {
        const {graph} = this.props;
        graph.selectionCellsHandler.removeListener(this.onCellSelectionAdd);
    };

    renderSelectedCYNYSymbol = () => {
        const {graph} = this.props;
        const {selectedObject} = this.state;
        return <SelectedCYNYSymbol onUpdateSymbolData={this.onUpdateSymbolData} selectedObject={selectedObject}
                                   graph={graph}/>
    };

    renderCYNYConnection = () => {
        const {graph} = this.props;
        const {selectedObject} = this.state;
        return <SelectCYNYConnection graph={graph}
                                     selectedObject={selectedObject}
                                     onUpdateConnectionData={this.onUpdateConnectionData}/>
    };

    renderCYNYText = (cell, graph) => {
        return (
            <div>
                <div className={styles.pinout_title}>
                    <span>SELECTED TEXT</span>
                </div>
                <Menu cynyText={cell} graph={graph}/>
            </div>
        )
    };

    showSelectedSymbol = () => {
        const {graph} = this.props;
        if (graph) {
            const cells = graph.getSelectionCells();
            if (cells.length > 1) {
                return (<div className={styles.pinout_divider}></div>);
            }
            const cell = cells[0];
            if (cell instanceof window.CYNYSymbol) {
                return this.renderSelectedCYNYSymbol();
            } else if (cell instanceof window.CYNYConnection) {
                return this.renderCYNYConnection();
            } else if (cell instanceof window.CYNYText) {
                return this.renderCYNYText(cell, graph);
            } else return (<div className={styles.pinout_divider}></div>);
        }
    };

    render() {
        return (
            <div ref={this.container}>
                {this.showSelectedSymbol()}
            </div>
        )
    }
}
